<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div style="padding: 6px;">查看回放</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px">

        <iframe id="iframePage" ref="iframePage" src="" frameborder="0"
                width="100%" height="350px"
                allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
                allow='microphone *;camera *'>
        </iframe>


      </div>
      <!--      <div class="modal-footer">-->
      <!--        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "ViewCamera",
  data(){

    return{
      sn:'',
      tdh:'',
      accessToken:'',
    }

  },
  methods:{

    init(sn,tdh){
      this.sn = sn;
      this.tdh = tdh;
      this.getAccessToken2();

      this.$refs.iframePage.src = "";

      // let that = this;
      // navigator.mediaDevices.getUserMedia({ audio: true }).then(function (mediaStream) {
      //   that.getAccessToken2();
      // }).catch(function (error) {
      //   console.log("error--->" + error);
      // })


    },

    closeSelf() {
      this.$emit("closeCamera");
    },

    getAccessToken2(){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/GetH5UrlBySN",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          sn:this.sn,
          tdh:this.tdh
        },
      }).then((response) => {
        console.log(response.data.data);
        if (response.data.error == 0) {

          let previewUrl = response.data.data.previewUrl;
          let playbackUrl = response.data.data.playbackUrl;

          playbackUrl = playbackUrl.replace("https://open.ys7.com/console/jssdk/pc.html","https://open.ys7.com/jssdk/theme.html");

          this.$refs.iframePage.src = playbackUrl;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

  }

}
</script>

<style lang="scss" scoped>
</style>
